import type { ReactNode } from 'react';

type Props = {
  /** Una riga che dice a cosa serve la scheda. */
  descrizione: string;
  /** I pulsanti della scheda (Nuova campagna, Importa...). */
  children?: ReactNode;
};

/**
 * Prima riga di ogni scheda di Mailing, sotto le linguette: a sinistra a
 * cosa serve la scheda, a destra i suoi pulsanti. Uguale su tutte le schede,
 * cosi' i pulsanti stanno sempre nello stesso punto.
 */
export function MailingIntestazione({ descrizione, children }: Props) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:min-h-10">
      <p className="text-sm text-neutral-500 leading-relaxed max-w-2xl">{descrizione}</p>
      {children && (
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 flex-shrink-0">
          {children}
        </div>
      )}
    </div>
  );
}
